import {
  SlSkeleton
} from "./chunk.KFR4Y7YR.js";
import {
  __objRest
} from "./chunk.5F6CPPXO.js";

// src/react/skeleton/index.ts
import * as React from "react";
import { createComponent } from "@lit-labs/react";
var tagName = "sl-skeleton";
var component = createComponent({
  tagName,
  elementClass: SlSkeleton,
  react: React,
  events: {},
  displayName: "SlSkeleton"
});
var SlComponent = class extends React.Component {
  constructor(...args) {
    super(...args);
    SlSkeleton.define(tagName);
  }
  render() {
    const _a = this.props, { children } = _a, props = __objRest(_a, ["children"]);
    return React.createElement(component, props, children);
  }
};
var skeleton_default = SlComponent;

export {
  skeleton_default
};
